import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const get = (item) => {
  const { window } = defaults
  const { localStorage } = window
  return localStorage.getItem(item)
}

const set = (item, value) => {
  const { window } = defaults
  const { localStorage } = window
  localStorage.setItem(item, value)
}

const remove = (item) => {
  const { window } = defaults
  const { localStorage } = window
  return localStorage.removeItem(item)
}

export default object(null, {
  get,
  set,
  remove
})
